import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { BackgroundGradient } from './components/BackgroundGradient/BackgroundGradient';
import { SettingsProvider, defaultSettings } from './context/Settings';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);

  root.render(
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      {/* Elements used/generated by external oneTrust script - have to be outside dimountable react components */}
      <div id="one-trust-container" style={{ display: 'none' }}>
        <button id="ot-sdk-btn" className="ot-sdk-show-settings">
          Cookie Settings
        </button>
        <div id="ot-sdk-cookie-policy"></div>
      </div>
      <SettingsProvider settings={defaultSettings}>
        <App />
      </SettingsProvider>
      <BackgroundGradient />
    </BrowserRouter>,
  );
}
